import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=66c82e24&scoped=true"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c82e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c82e24')) {
      api.createRecord('66c82e24', component.options)
    } else {
      api.reload('66c82e24', component.options)
    }
    module.hot.accept("./Story.vue?vue&type=template&id=66c82e24&scoped=true", function () {
      api.rerender('66c82e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview/Story.vue"
export default component.exports